import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import { get } from 'lodash';
import Filter from 'rp-react-common/Filter';
import FilteringComponent from '../../shared/filter';
import columns from './columns';
import categoriesFactory from './categories';
import categoriesReducer from './reducer';
import { getOption } from '../../utils/filter/selection';

const noDataText = 'No GB or IRE progeny results for this sire in the Racing Post database';

const emptyData = {
    progenyResults: [],
    seasonInfo: {},
};

class ProgenyResults extends FilteringComponent {
    constructor(props) {
        super(props);

        this.dataKey = 'progenyResults';
        const { data } = props;

        const {
            progenyResults,
            seasonInfo: { countryCode, raceType, surface, seasonYearBegin, seasonYearEnd },
        } = get(data, 'progenyResults.data', emptyData);

        const { seasonsAvailable } = get(data, 'availableSeasonsData.data', {});

        const surfaceUri = surface ? `/${surface}` : '';

        this.state = {
            data: progenyResults || [],
            categories: seasonsAvailable && categoriesFactory(seasonsAvailable, {
                raceType: `${countryCode}/${raceType}${surfaceUri}`,
                timePeriod: `${seasonYearBegin}/${seasonYearEnd}`,
            }),
            loading: false,
            fetchError: false,
        };
    }

    buildUrl = ({ raceType, timePeriod, month }) => {
        const { id } = this.props.params;
        return `horse/filter/progeny-results/${id}/${timePeriod}/${raceType}/${month}`;
    };

    renderStatus = () => {
        const { categories } = this.state;
        const typeCaption = getOption(categories, 'raceType').label;
        const seasonCaption = getOption(categories, 'timePeriod').label;
        const month = getOption(categories, 'month');

        return (
            <h2 className="ui-filter__statusText">
                <strong>{typeCaption}, {seasonCaption}</strong>
                {month.value && ` (${month.label})`}
            </h2>
        );
    };

    render() {
        const { data, categories, loading, fetchError } = this.state;

        return (
            <section className="hp-progeny-results">
                {categories && (
                    <Filter
                        categories={categories}
                        categoriesReducer={categoriesReducer}
                        columns={columns}
                        fetchError={fetchError}
                        onFilterApply={this.onFilterApply}
                    />
                )}
                {!fetchError && (
                    <RpTable
                        data={data}
                        columns={columns}
                        loading={loading}
                        initialSortIdx={0}
                        sortable
                        resultsPerPage={50}
                        noDataText={noDataText}
                    />
                )}
            </section>
        );
    }
}

ProgenyResults.propTypes = {
    data: PropTypes.shape({
        progenyResults: PropTypes.shape({
            data: PropTypes.shape({
                progenyResults: PropTypes.arrayOf(PropTypes.shape({
                    countryCode: PropTypes.string,
                    courseName: PropTypes.string,
                    courseRpAbbrev3: PropTypes.string,
                    courseUid: PropTypes.number,
                    distanceFurlong: PropTypes.number,
                    goingTypeCode: PropTypes.string,
                    horseName: PropTypes.string,
                    horseUid: PropTypes.number,
                    noOfRunners: PropTypes.number,
                    officialRatingRanOff: PropTypes.number,
                    prizeMoney: PropTypes.number,
                    raceDatetime: PropTypes.string,
                    raceDescription: PropTypes.string,
                    raceInstanceUid: PropTypes.number,
                    raceOutcomePosition: PropTypes.number,
                    rpPostmark: PropTypes.number,
                    rpTopspeed: PropTypes.number,
                })),
            }),
        }),
    }).isRequired,
};

export default ProgenyResults;



// WEBPACK FOOTER //
// ./src/js/horse/progenyResults/ProgenyResults.jsx